export function capitalize(data: string | undefined) {
  let newData: string;
  if (data !== undefined) {
    newData = data
      .toLowerCase()
      .replace(/(^|\s)[a-z]/g, (l) => l.toUpperCase());
    return newData;
  }
  newData = '';
  return newData;
}

export function cpfCnpjMask(data: string | undefined) {
  if (data !== undefined) {
    // remove apenas separadores de mascara e uppercase, preservando as letras
    // do CNPJ alfanumerico (12 primeiras posicoes podem ser [A-Z0-9])
    let cnpjOrCpf = data.replace(/[.\-/]/g, '').toUpperCase();

    if (cnpjOrCpf.length <= 12) {
      cnpjOrCpf = cnpjOrCpf.replace(
        /(\d{3})(\d{3})(\d{3})(\d{2})/,
        '$1.$2.$3-$4'
      );

      return cnpjOrCpf;
    }
    cnpjOrCpf = cnpjOrCpf.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2');
    cnpjOrCpf = cnpjOrCpf.replace(
      /^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/,
      '$1.$2.$3'
    );
    cnpjOrCpf = cnpjOrCpf.replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2');
    cnpjOrCpf = cnpjOrCpf.replace(/([A-Z0-9]{4})([A-Z0-9])/, '$1-$2');

    return cnpjOrCpf.slice(0, 18);
  }
  return data;
}

export function agencyAccountMask(
  agency: number,
  account: string,
  digit: number
) {
  let agencyString = agency.toString();
  while (agencyString.length < 4) {
    agencyString = `0${agencyString}`;
  }

  return `${agencyString}/${account}-${digit}`;
}

let vObj: string = '';
let vFun: Function = () => {};

function execmascara(obj, func: Function) {
  const newObj = func(obj);
  return newObj;
}

function mascara(o: string, f: Function) {
  vObj = o;
  vFun = f;
  return execmascara(vObj, vFun);
}

function mtel(v: string) {
  let number = v.replace(/\D/g, '');
  number = v.replace(/^(\d{2})(\d)/g, '($1) $2');
  number = v.replace(/(\d)(\d{4})$/, '$1-$2');
  return number;
}

export function celMask(props: any) {
  if (props !== undefined) {
    return mascara(props, mtel);
  }
  return props;
}
export function celMaskPhone(phone: any) {
  if (phone !== undefined) {
    return phone
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d)(\d{4})$/, '$1-$2');
  }
  return phone;
}

export function accountTypeMask(props: any) {
  if (props !== undefined) {
    if (props === 'F') {
      return 'Pessoa Física';
    }
    return 'Pessoa Jurídica';
  }
  return props;
}

export function accountIsClosed(props: any) {
  if (props === 0) {
    return 'Aberta';
  }
  return 'Encerrada';
}

export const MaskedAccount = (value: number | string) => {
  const inputValue = value;

  const digitsOnly = String(inputValue).replace(/\D/g, '');

  let formattedValue = '';
  if (digitsOnly.length > 4) {
    if (digitsOnly.length === 5) {
      formattedValue = `${digitsOnly.substring(0, 4)}-${digitsOnly.substring(
        4
      )}`;
    } else {
      formattedValue = `${digitsOnly.substring(0, 5)}-${digitsOnly.substring(
        5
      )}`;
    }
  } else {
    formattedValue = digitsOnly;
  }

  if (digitsOnly.length > 6) {
    return formattedValue.slice(0, 6);
  }
  return formattedValue;
};

export function accountIsInactive(status: any) {
  switch (status) {
    case 2:
      return 'Inativa';

    case 3:
      return 'Rejeitada';

    case 4:
      return 'Bloqueada';

    default:
      break;
  }
  return 'Ativa';
}

export function outstandingDebitsFareType(data: string) {
  switch (data) {
    case 'TARIFA_MENSAL':
      return 'Mensalidade';

    case 'TARIFA_BOLETO_VENCIDO':
      return 'Boleto Vencido';

    case 'TARIFA_ABERTURA_CONTA_PF':
      return 'Abertura de Conta: PF';

    case 'TARIFA_ABERTURA_CONTA_PJ':
      return 'Abertura de Conta: PJ';

    case 'TARIFA_ALTERACAO_BOLETO':
      return 'Boleto Alterado';

    default:
      return '';
  }
}
export function limitFareType(data: string) {
  switch (data) {
    case 'TARIFA_MENSAL':
      return 'Mensalidade';

    case 'TARIFA_BOLETO_VENCIDO':
      return 'Boleto Vencido';

    case 'TARIFA_ABERTURA_CONTA_PF':
      return 'Abertura de Conta: PF';

    case 'TARIFA_ABERTURA_CONTA_PJ':
      return 'Abertura de Conta: PJ';

    case 'TARIFA_ALTERACAO_BOLETO':
      return 'Boleto Alterado';

    default:
      return '';
  }
}
